import type { LeaseRow } from '../rfpTypes';

interface LeasePreviewTableProps {
    rows: LeaseRow[];
    onClear: () => void;
}

export default function LeasePreviewTable({ rows, onClear }: LeasePreviewTableProps) {
    const hasRegion = rows.some((r) => r.region);

    return (
        <div style={{ marginTop: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                <span style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>
                    {rows.length} lease{rows.length !== 1 ? 's' : ''} loaded
                </span>
                <button
                    onClick={onClear}
                    style={{
                        fontSize: 12,
                        color: '#ef4444',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                        padding: 0,
                    }}
                >
                    Clear
                </button>
            </div>

            <div style={{ overflowX: 'auto', maxHeight: 240, overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead>
                        <tr style={{ background: '#f3f4f6', position: 'sticky', top: 0 }}>
                            <Th>Lease Name</Th>
                            {hasRegion && <Th>Region</Th>}
                            <Th>Avg BBL/mo</Th>
                            <Th>Avg BS&W %</Th>
                            <Th>Avg Gravity</Th>
                            <Th>Latitude</Th>
                            <Th>Longitude</Th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, i) => (
                            <tr
                                key={i}
                                style={{ borderBottom: '1px solid #e5e7eb', background: i % 2 === 0 ? '#fff' : '#f9fafb' }}
                            >
                                <Td>{row.lease_name}</Td>
                                {hasRegion && <Td>{row.region ?? '—'}</Td>}
                                <Td>{row.avg_monthly_production_bbl.toLocaleString()}</Td>
                                <Td>{row.avg_bsw.toFixed(2)}</Td>
                                <Td>{row.avg_gravity.toFixed(1)}</Td>
                                <Td>{row.latitude.toFixed(4)}</Td>
                                <Td>{row.longitude.toFixed(4)}</Td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function Th({ children }: { children: React.ReactNode }) {
    return (
        <th
            style={{
                padding: '4px 8px',
                textAlign: 'left',
                fontWeight: 600,
                color: '#374151',
                whiteSpace: 'nowrap',
                borderBottom: '2px solid #d1d5db',
            }}
        >
            {children}
        </th>
    );
}

function Td({ children }: { children: React.ReactNode }) {
    return (
        <td style={{ padding: '3px 8px', color: '#374151', whiteSpace: 'nowrap' }}>
            {children}
        </td>
    );
}
